import axios from '@/axios';

export default {
  fetchProductFamilies() {
    return axios.get('/api/v1/admins/product-family/list');
  },
  createProductFamily(_, data) {
    return axios.post('/api/v1/admins/product-family/create', data);
  },
  updateProductFamily(_, data) {
    return axios.patch(`/api/v1/admins/product-family/update/${data._id}`, data);
  },
  deleteProductFamily(_, data) {
    return axios.delete(`/api/v1/admins/product-family/delete/${data._id}`);
  },
};
